export default "__VITE_ASSET__DMVJir64__"